import { Charts } from './Charts';
import SpotsChartsDataProvider from './contexts/SpotsChartsDataContext';

const SpotsWrapper = () => {
    return (
        <SpotsChartsDataProvider>
            <Charts />
        </SpotsChartsDataProvider>
    );
};

export default SpotsWrapper;
